import { render, staticRenderFns } from "./FeaturedWorkforceCard.vue?vue&type=template&id=04661c38&scoped=true&"
import script from "./FeaturedWorkforceCard.vue?vue&type=script&lang=js&"
export * from "./FeaturedWorkforceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04661c38",
  null
  
)

export default component.exports